var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 24,
    viewBox: "0 0 73 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1733 1",
    clipPath: "url(#clip0_99_12983)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.8276 0.413574H12C5.60114 0.413574 0.413818 5.6009 0.413818 11.9998C0.413818 18.3987 5.60114 23.586 12 23.586H60.8276C67.2265 23.586 72.4138 18.3987 72.4138 11.9998C72.4138 5.6009 67.2265 0.413574 60.8276 0.413574Z",
    fill: "url(#paint0_linear_99_12983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.827586C5.82965 0.827586 0.827586 5.82965 0.827586 12C0.827586 18.1704 5.82965 23.1724 12 23.1724H60.8276C66.9979 23.1724 72 18.1704 72 12C72 5.82965 66.9979 0.827586 60.8276 0.827586H12ZM0 12C0 5.37258 5.37258 0 12 0H60.8276C67.455 0 72.8276 5.37258 72.8276 12C72.8276 18.6274 67.455 24 60.8276 24H12C5.37258 24 0 18.6274 0 12Z",
    fill: "url(#paint1_linear_99_12983)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.4193 12.4541L26.8476 14.2243L28.3751 14.153L27.0331 15.1523L28.9176 16.6941L25.7769 16.7512L26.1623 18.6213L38.668 18.2216L38.3682 16.5085L35.4702 16.5656L37.1976 14.7954L35.5987 13.7818L37.9256 13.6676L37.5116 12.0972L33.2146 12.24L33.2289 11.0123L36.0698 10.8695L35.8984 10.17C36.4124 10.4412 36.9549 10.6982 37.5116 10.9695L38.7964 9.2278C36.598 8.42835 34.8563 7.6289 33.0718 6.64387L33.5429 6.15849L31.7299 5.70166C29.874 7.25773 28.218 8.35697 25.5199 9.88449L26.9618 11.5119L28.3608 10.5697L28.5178 11.255L31.0447 11.1265L31.0589 12.3114L26.4193 12.4541ZM33.186 13.9103L35.4416 13.7961L33.857 15.9803L34.7992 16.5799L33.1289 16.6084L33.186 13.9103ZM31.8869 7.77166C32.6293 8.28559 33.443 8.79952 34.3281 9.31345L29.9311 9.41338C30.6307 8.88518 31.2588 8.34269 31.8869 7.77166ZM30.545 15.9946L28.9033 14.1244L31.0875 14.0102L31.1303 16.6512L29.6742 16.6798L30.545 15.9946ZM40.7347 11.3692L41.0202 12.8681L43.0188 12.7825C42.976 12.8824 42.9189 12.9252 42.8618 13.0252L39.564 13.1537L39.9352 14.6812L41.7482 14.5955C41.1629 15.3236 40.492 16.0945 39.6354 17.0224L40.9631 18.5785C41.6483 17.7933 42.2479 17.1509 42.7618 16.4799L43.961 16.4228L43.4328 16.6798L44.6891 18.2501L46.3736 17.0367L45.3743 16.3515L48.2152 16.223L48.2295 17.1795L46.5878 17.2508V18.3072L50.0711 18.9211L50.1424 16.1373L52.2838 16.0374L51.7699 14.724L50.1853 14.7811L50.1996 14.153L52.3124 14.0388L52.0269 12.6683L45.046 12.9395C45.0888 12.8396 45.1459 12.7682 45.1887 12.6683L51.1275 12.3828L50.8562 11.0837L45.8311 11.2264L45.9453 10.9552L51.8556 10.7981L51.5129 9.27063L46.5164 9.48476L46.6306 9.17069L44.9889 8.71387C44.9746 8.72814 44.9746 8.74242 44.9746 8.75669L44.4607 8.11428L45.9596 7.92869L45.46 8.64249L47.4443 9.02794L47.9011 8.28559L48.6149 8.19994L49.186 9.08504L51.1703 8.79952L50.4137 7.9858L52.3838 7.74311L51.8413 6.3869L48.8291 6.60104L49.1717 5.85869L47.3158 5.71594C46.9875 6.35835 46.6163 6.98649 46.1167 7.71456L45.6598 6.54394L42.9617 6.72952L43.3186 6.01573L41.4913 5.74449C40.9773 6.71525 40.3207 7.81449 39.4213 9.07076L41.3771 9.62752C41.6483 9.18497 41.8767 8.79952 42.0909 8.41407L42.6191 8.34269L43.0331 9.18497L44.8747 8.98511L44.632 9.57042L39.9067 9.77028L40.235 11.0979L43.9753 10.998L43.8468 11.2835L40.7347 11.3692ZM48.1724 14.2529L48.1867 14.8382L43.8753 14.9524C43.9896 14.7954 44.0895 14.6241 44.1894 14.467L48.1724 14.2529ZM53.1656 6.95794L53.7509 8.78525L54.9358 8.62821C54.4219 10.1129 53.7652 11.5119 52.8516 13.1537L53.808 15.0952L54.2363 14.3528L54.2791 17.8647L58.4334 17.6934L58.462 10.3699L55.9922 10.6554C56.3206 9.84166 56.6204 9.07076 56.8345 8.38552L58.8331 8.11428L58.4477 6.55821L53.1656 6.95794ZM61.4884 8.8138L59.7468 8.85663L59.19 13.4392L63.9439 13.1537L63.9011 16.6941L61.36 16.6798L61.3742 17.7933L65.5571 18.8926L65.9568 11.3977L64.6862 11.4548L65.3001 6.35835L58.7189 6.71525L59.2329 8.38552L63.3871 8.05718L62.8875 11.5405L61.1887 11.6119L61.4884 8.8138ZM58.7047 14.6241L59.1472 16.2943L63.8011 15.6948L63.6441 14.2672L58.7047 14.6241ZM55.978 16.1801L56.0208 12.2971L56.7631 12.083L56.8202 16.0517L55.978 16.1801Z",
    fill: "url(#paint2_linear_99_12983)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.7985 11.8335L26.2268 13.6037L27.7543 13.5324L26.4124 14.5317L28.2968 16.0735L25.1561 16.1306L25.5416 18.0007L38.0472 17.601L37.7474 15.8879L34.8494 15.945L36.5768 14.1748L34.9779 13.1612L37.3049 13.047L36.8909 11.4766L32.5939 11.6194L32.6081 10.3917L35.449 10.2489L35.2777 9.5494C35.7917 9.82064 36.3341 10.0776 36.8909 10.3488L38.1757 8.60719C35.9772 7.80774 34.2356 7.0083 32.4511 6.02326L32.9222 5.53788L31.1092 5.08105C29.2533 6.63712 27.5973 7.73637 24.8992 9.26388L26.341 10.8913L27.7401 9.94912L27.8971 10.6344L30.4239 10.5059L30.4382 11.6908L25.7985 11.8335ZM32.5653 13.2897L34.8209 13.1755L33.2363 15.3597L34.1785 15.9593L32.5082 15.9878L32.5653 13.2897ZM31.2662 7.15105C32.0085 7.66499 32.8223 8.17892 33.7074 8.69285L29.3104 8.79278C30.0099 8.26457 30.6381 7.72209 31.2662 7.15105ZM29.9243 15.374L28.2826 13.5038L30.4668 13.3896L30.5096 16.0306L29.0534 16.0592L29.9243 15.374ZM40.1139 10.7486L40.3994 12.2475L42.3981 12.1619C42.3552 12.2618 42.2981 12.3046 42.241 12.4046L38.9433 12.5331L39.3145 14.0606L41.1275 13.9749C40.5422 14.703 39.8712 15.4739 39.0147 16.4018L40.3423 17.9579C41.0276 17.1727 41.6272 16.5303 42.1411 15.8593L43.3403 15.8022L42.8121 16.0592L44.0683 17.6295L45.7529 16.4161L44.7536 15.7308L47.5945 15.6024L47.6088 16.5588L45.967 16.6302V17.6866L49.4503 18.3005L49.5217 15.5167L51.6631 15.4168L51.1492 14.1034L49.5645 14.1605L49.5788 13.5324L51.6917 13.4182L51.4061 12.0477L44.4252 12.3189C44.4681 12.219 44.5252 12.1476 44.568 12.0477L50.5068 11.7622L50.2355 10.4631L45.2104 10.6058L45.3246 10.3346L51.2348 10.1775L50.8922 8.65002L45.8957 8.86416L46.0099 8.55009L44.3681 8.09326C44.3539 8.10754 44.3539 8.12181 44.3539 8.13609L43.8399 7.49368L45.3389 7.30809L44.8392 8.02188L46.8236 8.40733L47.2804 7.66499L47.9942 7.57933L48.5652 8.46443L50.5496 8.17892L49.793 7.36519L51.763 7.1225L51.2205 5.7663L48.2083 5.98043L48.551 5.23809L46.6951 5.09533C46.3668 5.73774 45.9956 6.36588 45.4959 7.09395L45.0391 5.92333L42.341 6.10892L42.6979 5.39512L40.8705 5.12388C40.3566 6.09464 39.6999 7.19388 38.8005 8.45016L40.7563 9.00692C41.0276 8.56436 41.256 8.17892 41.4701 7.79347L41.9983 7.72209L42.4123 8.56436L44.2539 8.3645L44.0112 8.94981L39.2859 9.14967L39.6143 10.4773L43.3545 10.3774L43.2261 10.6629L40.1139 10.7486ZM47.5517 13.6323L47.5659 14.2176L43.2546 14.3318C43.3688 14.1748 43.4688 14.0035 43.5687 13.8464L47.5517 13.6323ZM52.5449 6.33733L53.1302 8.16464L54.3151 8.00761C53.8012 9.4923 53.1445 10.8913 52.2308 12.5331L53.1873 14.4746L53.6156 13.7322L53.6584 17.2441L57.8127 17.0728L57.8412 9.74926L55.3715 10.0348C55.6999 9.22105 55.9997 8.45016 56.2138 7.76492L58.2124 7.49368L57.827 5.93761L52.5449 6.33733ZM60.8677 8.19319L59.1261 8.23602L58.5693 12.8186L63.3232 12.5331L63.2803 16.0735L60.7392 16.0592L60.7535 17.1727L64.9363 18.272L65.3361 10.7771L64.0655 10.8342L64.6794 5.73774L58.0982 6.09464L58.6121 7.76492L62.7664 7.43657L62.2668 10.9199L60.5679 10.9913L60.8677 8.19319ZM58.0839 14.0035L58.5265 15.6737L63.1804 15.0742L63.0234 13.6466L58.0839 14.0035ZM55.3572 15.5595L55.4001 11.6765L56.1424 11.4624L56.1995 15.4311L55.3572 15.5595Z",
    fill: "url(#paint3_radial_99_12983)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_d_99_12983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9678 21.5008C17.2062 21.5008 21.4528 17.2534 21.4528 12.0141C21.4528 6.77469 17.2062 2.52734 11.9678 2.52734C6.72929 2.52734 2.48267 6.77469 2.48267 12.0141C2.48267 17.2534 6.72929 21.5008 11.9678 21.5008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24133 12.0142C1.24133 6.08948 6.04354 1.28613 11.9678 1.28613C17.8921 1.28613 22.6942 6.08948 22.6942 12.0142C22.6942 17.939 17.8921 22.7423 11.9678 22.7423C6.04354 22.7423 1.24133 17.939 1.24133 12.0142ZM11.9678 2.52751C6.72934 2.52751 2.48271 6.77486 2.48271 12.0142C2.48271 17.2536 6.72933 21.5009 11.9678 21.5009C17.2063 21.5009 21.4529 17.2536 21.4529 12.0142C21.4529 6.77486 17.2063 2.52751 11.9678 2.52751Z",
    fill: "url(#paint4_radial_99_12983)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.1034 3.31035L16.0344 3.72414L16.1248 3.37817C16.3001 2.70677 16.3888 2.01569 16.3888 1.32178C16.0688 2.01529 15.6555 2.66181 15.1604 3.2434L15.1034 3.31035Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5173 11.9984C21.5173 12.8988 21.3886 13.751 21.1637 14.571C21.1153 12.2396 19.9418 10.2457 18.2537 9.02373C19.1058 9.10413 20.199 9.36139 20.8742 9.81162C19.2023 7.72132 16.614 6.41891 14.2186 6.22595C15.1992 5.45415 15.8101 4.50549 16.1317 3.4121C19.3148 4.95569 21.5173 8.21977 21.5173 11.9984ZM2.48279 11.9984C6.18036 20.9222 16.1317 15.4876 12.5306 11.8215C11.9679 11.516 11.2766 11.3231 10.5371 11.2266C8.70435 11.0015 7.01635 11.5482 8.0613 12.5611C7.03242 12.4647 6.16428 12.1431 5.63376 11.3552C5.473 11.4838 5.31224 11.6125 5.15146 11.7411C4.84602 10.4548 4.78172 9.15236 6.61443 7.8178C6.11606 9.13628 7.38609 9.05589 8.55967 7.78562C8.7526 7.9625 9.04197 8.02682 9.41173 7.91427C9.10627 7.8821 8.88121 7.7374 8.76868 7.56052C8.44714 7.09422 8.7365 6.29026 9.65287 5.96868C10.9551 5.5024 12.3055 4.76274 12.6109 3.92663C12.836 4.26429 12.9646 4.66626 13.0128 5.10042C13.881 4.55371 14.6526 3.87838 15.3118 3.05835C14.2668 2.68852 13.1575 2.47949 12 2.47949C6.74304 2.47949 2.48279 6.74048 2.48279 11.9984ZM5.77846 10.0206C6.0196 9.61866 6.59835 9.40964 6.59835 9.77944C6.90379 9.00766 6.05175 9.18451 5.77846 10.0206ZM9.62072 7.54444C10.4406 7.38364 10.9551 7.01384 11.148 6.35458C10.3924 6.66008 9.55642 6.83696 9.62072 7.54444Z",
    fill: "url(#paint5_radial_99_12983)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0997 8.92723C11.8393 9.28098 12.4019 9.76336 12.7717 10.3583C9.91008 9.58649 7.53077 9.94022 5.63376 11.3552C6.16428 12.1431 7.03242 12.4647 8.0613 12.5611C7.01635 11.5481 8.70435 11.0015 10.5371 11.2266C11.2766 11.323 11.9518 11.516 12.5306 11.8215C16.1317 15.4875 6.18036 20.9224 2.48279 11.9984C2.48279 17.2563 6.74304 21.5172 12 21.5172C22.4336 21.5172 20.1669 8.34838 11.0997 8.92723Z",
    fill: "url(#paint6_linear_99_12983)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0417 15.7285C14.6526 13.9116 13.9131 12.5609 12.5306 11.8213C16.1317 15.4874 6.18036 20.9222 2.48279 11.9982C2.48279 14.0241 3.12584 15.9054 4.20297 17.449C8.80083 24.0093 17.8358 18.5102 15.5368 13.9277C15.4404 14.7316 14.6687 15.407 14.0417 15.7285Z",
    fill: "url(#paint7_linear_99_12983)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0997 8.92708C11.4534 9.08786 11.7589 9.28081 12.0322 9.50592C17.6107 9.9079 20.3115 16.227 17.2409 19.7484C21.035 16.1949 18.093 8.47685 11.0997 8.92708Z",
    fill: "url(#paint8_linear_99_12983)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63379 11.3552C7.67551 10.1331 10.0709 10.0367 12.836 11.0818C12.6753 10.7763 12.4824 10.4869 12.2412 10.2296C9.62075 9.65077 7.41827 10.0367 5.63379 11.3552Z",
    fill: "url(#paint9_linear_99_12983)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0224 14.9729C15.9709 17.835 11.9036 20.7613 8.88123 20.4237C13.045 20.9223 17.1767 17.2079 15.5369 13.9277C15.4565 14.394 15.3279 14.6352 15.0224 14.9729Z",
    fill: "url(#paint10_linear_99_12983)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5305 11.8213C13.6559 12.577 14.0739 14.1367 13.4469 15.3426C13.7362 15.1979 14.0096 15.021 14.2507 14.7799C14.3632 13.4453 13.6719 12.4323 12.5305 11.8213Z",
    fill: "url(#paint11_linear_99_12983)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9259 4.10331L15.6171 3.89429C14.8615 4.97158 13.9613 5.69516 12.8841 6.11321C12.7555 6.61167 12.4822 7.06187 12.0803 7.39955C12.9324 7.07795 13.6397 6.69207 14.2024 6.24184C15.1831 5.47003 15.794 4.52137 16.1155 3.42798C16.3245 2.75265 16.4209 2.01301 16.4209 1.24121C16.2441 1.93262 15.9708 2.57578 15.585 3.18678C15.4081 3.50838 15.1831 3.79781 14.9259 4.10331Z",
    fill: "url(#paint12_linear_99_12983)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9259 4.10331C15.6493 3.26718 16.1638 2.31852 16.4371 1.24121C16.2602 2.23812 15.8744 3.15463 15.2796 3.99076L14.9259 4.10331ZM12.8842 6.09714C12.836 6.27399 12.7717 6.45087 12.6913 6.61167C14.4436 5.93633 15.151 5.06805 15.8101 3.94251L15.4886 4.05507C14.7812 5.0359 13.9131 5.71123 12.8842 6.09714Z",
    fill: "url(#paint13_linear_99_12983)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5271 8.63774C17.4017 8.0589 16.2282 7.7534 15.0063 7.7373C16.196 7.88203 17.3053 8.33224 18.2538 9.02364C19.1058 9.10404 20.199 9.36132 20.8743 9.81153C20.0865 9.15229 19.2184 8.55736 18.1895 8.07498L18.5271 8.63774Z",
    fill: "url(#paint14_linear_99_12983)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2859 8.52515L18.4628 8.78241C17.9805 8.57338 17.4982 8.4126 16.9998 8.28395C16.3728 7.99454 15.6976 7.81767 15.0063 7.72119C16.1317 7.75334 17.2249 8.02669 18.2859 8.52515ZM18.3502 8.3322C19.2987 8.73418 20.1187 9.24871 20.8743 9.79541C20.0865 9.13616 19.2184 8.54123 18.1895 8.05885L18.3502 8.3322Z",
    fill: "url(#paint15_linear_99_12983)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.39,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62073 7.54433C11.0194 7.59258 11.6946 6.93332 11.9357 5.88818C11.7267 6.09721 11.4374 6.24191 11.1319 6.35447C10.9711 6.99765 10.4406 7.38355 9.62073 7.54433Z",
    fill: "url(#paint16_linear_99_12983)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.39,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77844 10.0207C6.03566 9.18461 6.88772 9.00774 6.59833 9.77954C7.08063 8.76656 5.97135 8.91126 5.77844 10.0207Z",
    fill: "url(#paint17_linear_99_12983)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_99_12983",
    x: 1.24133,
    y: 1.28613,
    width: 23.4529,
    height: 23.4561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_12983"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_99_12983",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_12983",
    x1: 67.3399,
    y1: 23.1722,
    x2: -23.8154,
    y2: -20.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_12983",
    x1: 67.3399,
    y1: 23.1724,
    x2: 4.84514,
    y2: -2.46377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B91C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_12983",
    x1: 109.325,
    y1: -3.03196,
    x2: 98.4745,
    y2: 33.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B91C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_99_12983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9212 3.10354) rotate(21.0435) scale(67.7023 38.4488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328722,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590493,
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678938,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_99_12983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.03443 0.930829) rotate(49.4152) scale(38.9578 32.9123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533697,
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671657,
    stopColor: "#EF4444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_99_12983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.942228 -5.37111) rotate(47.7815) scale(43.4307 43.4381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127561,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325744,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743441,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_99_12983",
    x1: 25.3484,
    y1: -8.7239,
    x2: 6.44506,
    y2: 21.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_99_12983",
    x1: -20.3215,
    y1: 16.1506,
    x2: 19.6121,
    y2: 16.1506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7001,
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_99_12983",
    x1: 26.8506,
    y1: 3.38956,
    x2: 12.5448,
    y2: 15.7512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC2626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_99_12983",
    x1: 22.7272,
    y1: -1.17097,
    x2: 6.09185,
    y2: 14.1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_99_12983",
    x1: 28.8081,
    y1: 17.2044,
    x2: 8.17569,
    y2: 17.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_99_12983",
    x1: 27.5458,
    y1: 13.5917,
    x2: 8.45291,
    y2: 13.5917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_99_12983",
    x1: 13.1019,
    y1: 5.79645,
    x2: 17.8086,
    y2: 1.47891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_99_12983",
    x1: 10.1617,
    y1: 10.1496,
    x2: 17.9502,
    y2: 0.386366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_99_12983",
    x1: 9.45625,
    y1: 8.77121,
    x2: 21.6272,
    y2: 8.77121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_99_12983",
    x1: 3.41555,
    y1: 8.77115,
    x2: 23.2639,
    y2: 8.77115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_99_12983",
    x1: 5.27201,
    y1: 6.71682,
    x2: 11.5827,
    y2: 6.71682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_99_12983",
    x1: 7.73713,
    y1: 9.56025,
    x2: 6.16277,
    y2: 9.56025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_12983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.8276,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/mainLogo.de09392ebcf53c58934d46f26efe44a3.svg";
export { ForwardRef as ReactComponent };